export function toSet<TSource>(source: Iterable<TSource>): Set<TSource> {
  let set = new Set<TSource>();
  for (let item of source) {
    set.add(item);
  }
  return set;
}



// WEBPACK FOOTER //
// ./node_modules/ix/iterable/toset.ts